import { css } from 'styled-components';
import { getSpacingStyle } from './spacing';
export const set = (topOrAll, right, bottom, left) => css `
    padding: ${getSpacingStyle(topOrAll, right, bottom, left)};
  `;
export const setTop = (top) => css `
    padding-top: ${top};
  `;
export const setBottom = (bottom) => css `
    padding-bottom: ${bottom};
  `;
export const setLeft = (left) => css `
    padding-left: ${left};
  `;
export const setRight = (right) => css `
    padding-right: ${right};
  `;
//# sourceMappingURL=padding.js.map